import type { DivisionDto } from 'shared/dtos/divisions.dto';

import { Button } from 'components/buttons/button/button';
import { DivisionsList } from 'components/lists/divisions-list/divisions-list';
import { GrayPanel } from 'components/panels/gray-panel/gray-panel';
import { FormBody } from 'components/template/form-body/form-body';
import { FormHeader } from 'components/template/form-header/FormHeader';
import { PermissionsContext } from 'contexts';
import { useContext, useEffect, useState } from 'react';
import { ASSIGN_DIVISION_MODAL, MODAL_DIVISION } from 'shared/constants/modals';
import { useAppDispatch, useAppSelector } from 'store';
import { setSelectedDivisions as setSelectedDivisionsAction } from 'store/divisions/divisions.slice';
import { getDivisionsThunk } from 'store/divisions/divisions.thunks';
import { closeModal, openModal } from 'store/modals/modals.slice';
import { vocabulary } from 'vocabulary/german';

export const AssignDivisionsForm = () => {
  const dispatch = useAppDispatch();
  const { permissions } = useContext(PermissionsContext);
  const divisions = useAppSelector((state) => state.divisions);
  const currentYearFrozen = useAppSelector(
    (state) => state.years.currentYearFrozen,
  );
  const [selectedDivisions, setSelectedDivisions] = useState<number[]>([]);

  const renderSaveButton = () => {
    if (permissions.edit === true || !currentYearFrozen) {
      return (
        <Button
          disabled={selectedDivisions.length === 0}
          onClick={handleSubmit}
          text={vocabulary.buttons.save}
        />
      );
    }
  };

  const handleSubmit = () => {
    dispatch(setSelectedDivisionsAction(selectedDivisions));
    dispatch(closeModal({ name: ASSIGN_DIVISION_MODAL, data: {} }));
  };

  const handleCreateClick = () => {
    dispatch(openModal({ name: MODAL_DIVISION }));
  };

  const selectDivision = (division: DivisionDto) => {
    // toggle divisions from local state
    if (selectedDivisions.some((val) => val === division.id)) {
      const array: number[] = [...selectedDivisions];
      const index = array.indexOf(division.id);
      if (index > -1) {
        array.splice(index, 1);
        setSelectedDivisions(array);
      }
    } else {
      setSelectedDivisions([...selectedDivisions, division.id]);
    }
  };

  useEffect(() => {
    dispatch(getDivisionsThunk());
  }, [dispatch]);

  return (
    <>
      <FormHeader renderSave={renderSaveButton()} />
      <FormBody noMargin>
        <GrayPanel text={vocabulary.labels.assignDivisionToAgency} />
        <div className="container">
          {divisions && (
            <DivisionsList
              showDisabledItems
              selectable
              divisions={divisions.list}
              onCreate={handleCreateClick}
              onSelect={(division) => selectDivision(division)}
            />
          )}
        </div>
      </FormBody>
    </>
  );
};
